import React from "react";
import BackgroundVideo from "../layout/BackgroundVideo";
import SocialBar from "./SocialBar";
import DarkModeToggle from "./DarkModeToggle";
import Footer from "../layout/Footer";
import Header from "../layout/Header";

const Layout = ({ children }) => {
    return (
        <section className="relative min-h-screen text-white overflow-hidden">

            {/* Fondo de video */}
            <BackgroundVideo />

            {/* Barra social + modo oscuro */}
            <SocialBar />
            <DarkModeToggle />
            <Header />
            {/* Layout principal con footer abajo */}
            <div className="relative z-10 flex flex-col min-h-screen backdrop-blur-md">
                <main className="flex-1 flex items-center justify-center px-6 py-20">
                    {children}
                </main>
                <Footer />
            </div>
        </section>
    );
};

export default Layout;
